import React from "react";

interface PrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isLoading?: boolean;
  loadingText?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  isLoading = false,
  loadingText = "Loading...",
  disabled,
  className = "",
  ...rest
}) => {
  return (
    <button
      disabled={disabled || isLoading}
      className={`
        flex
        py-3 px-6 rounded-lg
        bg-primary
        hover:from-blue-700 hover:to-purple-700
        text-white font-medium
        transition-all duration-200 ease-in-out
        disabled:opacity-50 disabled:cursor-not-allowed
        transform hover:scale-[1.02] active:scale-[0.98]
        ${className}
      `}
      {...rest}
    >
      {isLoading ? (
        <div className="flex items-center justify-center space-x-2">
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>{loadingText}</span>
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default PrimaryButton;
